import { Record } from 'immutable'

export const Org = Record({
  id: null,
  handle: "",
  name: "",
  createdAt: null,
  status: null,
  properties: null
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/org/models.js